export enum OptionWindow {
  abrir = 1,
  imprimir = 2,
  anular = 3,
  bloquear = 4,
  eliminar = 5,
  Activar = 6,
  Inactivar = 7,
  VerTodo = 8,
  Importar = 9,
  Exportar = 10,
  ExportarVistaPrevia = 11,
  CierreInicialOM = 13,
  CierreFinalOM = 14,
}